import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IndicadorClienteListarComponent } from './indicador-cliente-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: IndicadorClienteListarComponent }
    ])],
    exports: [RouterModule]
})
export class IndicadorClienteListarRoutingModule { }
